import { Text } from 'iq-blueberry'

import './style.styl'

const StepTitle = ({ children }) => {
  return (
    <div className="step-title">
      <Text as="h1" variant="heading-three">
        {children}
      </Text>
    </div>
  )
}

export default StepTitle
